import React from 'react';
import Rating from 'react-rating';
import {PropTypes} from "prop-types";

// This is a simple wrapper for the react-rating component.
// See  the react-rating documentation for a complete
// list of all available options
export default class StarsRating extends React.Component{


  render(){
    return(
        <span id={this.props.containerId}>
          <Rating  emptySymbol="fa fa-star-o rating empty-star-color"
            fullSymbol="fa fa-star rating full-star-color"  readonly={this.props.readonly} {...this.props}  />
        </span>
    );
  }

}


StarsRating.propTypes = {
    containerId: PropTypes.string,
    readOnly: PropTypes.bool
};
